
import Vue from 'vue';

export default Vue.extend({
    name: 'appointment-title',
    props: {
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        subtitleFormat: {
            type: String as () => 'flat' | 'raised',
            required: true,
        },
    },
})
